
import Vue from 'vue';
import { modalNames } from '@/components/partials/jobs/constants';
import JobsDesiredCriteriaModalForm from '@/components/partials/jobs/JobsDesiredCriteriaModal/JobsDesiredCriteriaModalForm.vue';
import JobsEditModal from '@/components/partials/jobs/JobsEditModal.vue';
import type { InquiryAndUserInput } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default Vue.extend({
  name: 'JobsDesiredCriteriaModal',
  components: {
    JobsEditModal,
    JobsDesiredCriteriaModalForm,
  },
  data() {
    return {
      modalName: modalNames.JOBS_EDIT_DESIRED_CRITERIA,
    };
  },
  methods: {
    handleSave(): void {
      (this.$refs.form as Vue & { save: () => void }).save();
    },
    handleUpsert(payload: InquiryAndUserInput): void {
      if (!this.$attrs.adminPrivilege) {
        this.$analytics.logEvent('jobs__desired-criteria__save');
      }

      this.$emit('upsert', { ...payload, modalName: this.modalName });
    },
  },
});
